/* BadmintonFun gemeinsame Filter-Engine: ODER innerhalb der Gruppe, UND zwischen Gruppen. */
(() => {
  'use strict';
  function init(panel) {
    if (panel.dataset.bfReady === '1') return;
    panel.dataset.bfReady = '1';
    const kind = panel.dataset.bfKind;
    const groups = Array.from(panel.querySelectorAll('[data-bf-group]'));
    const price = panel.querySelector('[data-bf-price]');
    const low = price?.querySelector('[data-bf-price-min]');
    const high = price?.querySelector('[data-bf-price-max]');
    const minimum = Number(price?.dataset.min ?? 0);
    const maximum = Number(price?.dataset.max ?? 1);
    const count = panel.querySelector('[data-bf-count]');
    const empty = panel.querySelector('[data-bf-empty]');
    let frame = 0;
    let grid = null;
    const select = key => Array.from(panel.querySelectorAll('[data-bf-group="' + key + '"] input:checked'), cb => cb.value.toLocaleLowerCase('de-DE').trim());
    const normalize = val => String(val ?? '').toLocaleLowerCase('de-DE').trim();
    function cardValues(card, group) {
      const racketKeys = {vendor:'bfVendor',level:'bfLevel',balance:'bfBalance',flex:'bfFlex'};
      const ballKeys = {type:'bfBallType',brand:'bfBallBrand',speed:'bfBallSpeed',feather:'bfBallFeather',cork:'bfBallCork'};
      return normalize(card.dataset[(kind === 'racket' ? racketKeys : ballKeys)[group]]).split('|').map(x => x.trim());
    }
    function matches(card) {
      if (low && high) {
        const cents = Number(kind === 'racket' ? card.dataset.bfPriceCents : card.dataset.bfBallPrice);
        if (!Number.isFinite(cents) || cents < Number(low.value)*100 || cents >= (Number(high.value)+1)*100) return false;
      }
      return groups.every(group => {
        const key = group.dataset.bfGroup;
        const chosen = select(key);
        if (!chosen.length) return true;
        const values = cardValues(card,key);
        if(key === 'balance' && values.includes('leicht grifflastig')) values.push('grifflastig');
        return chosen.some(item => values.includes(item));
      });
    }
    function renderPrice() {
      if(!low || !high)return;
      const min=Number(low.value),max=Number(high.value),span=Math.max(1,maximum-minimum);
      const minOut=price.querySelector('[data-bf-min-label]'),maxOut=price.querySelector('[data-bf-max-label]');
      if(minOut)minOut.textContent=min+' €';
      if(maxOut)maxOut.textContent=max+' €';
      const fill=price.querySelector('[data-bf-price-fill]');
      if(fill){fill.style.left=((min-minimum)/span*100)+'%';fill.style.right=(100-(max-minimum)/span*100)+'%';}
      low.style.zIndex=min>(minimum+maximum)/2?'4':'2';
      high.style.zIndex=max<(minimum+maximum)/2?'3':'4';
      const priceSelected=price.querySelector('[data-bf-price-selected]');
      if(priceSelected){priceSelected.hidden=min===minimum&&max===maximum;priceSelected.textContent='Aktiv';}
    }
    function refresh() {
      frame=0;
      const root=document.querySelector('collection-component');
      if(!root)return;
      const newGrid=root.querySelector('#ResultsList .product-grid');
      if(!newGrid)return;
      grid=newGrid;
      const attr=kind==='racket'?'data-bf-price-cents':'data-bf-ball-type';
      const cards=Array.from(grid.querySelectorAll(':scope > .product-grid__item['+attr+']'));
      let visible=0;
      for(const card of cards) {
        const show=matches(card);
        card.hidden=!show;
        card.style.display=show?'':'none';
        if(show)visible++;
      }
      if(count) count.textContent=cards.length?(visible+' '+(kind==='racket'?(visible===1?'Schläger':'Schläger'):(visible===1?'Ball':'Bälle'))):'';
      if(empty)empty.hidden=(visible>0 || cards.length===0);
      groups.forEach(group=>{
        const n=group.querySelectorAll('input:checked').length;
        group.dataset.selected=n?'true':'false';
        const badge=group.querySelector('[data-bf-selected-count]');
        if(badge){badge.textContent=n;badge.hidden=n===0;}
      });
      // Shopify handles sorting natively on both racket and ball collections.
    }
    function schedule(){if(frame)return;frame=requestAnimationFrame(refresh);}
    const dropdowns = price ? [price, ...groups] : [...groups];
    groups.forEach(group=>{
      group.addEventListener('change',event=>{if(event.target.matches('input[type="checkbox"]'))schedule();});
    });
    dropdowns.forEach(group=>{
      group.addEventListener('toggle',()=>{
        if(group.open)dropdowns.forEach(other=>{if(other!==group)other.open=false;});
      });
    });
    if(low&&high){
      low.addEventListener('input',()=>{if(Number(low.value)>Number(high.value))high.value=low.value;renderPrice();schedule();});
      high.addEventListener('input',()=>{if(Number(high.value)<Number(low.value))low.value=high.value;renderPrice();schedule();});
    }
    panel.querySelector('[data-bf-clear]')?.addEventListener('click',()=>{
      panel.querySelectorAll('[data-bf-group] input:checked').forEach(el=>el.checked=false);
      if(low)low.value=minimum;
      if(high)high.value=maximum;
      renderPrice();schedule();
    });
    // Support asynchronous Shopify results and infinite scroll.
    const target=document.querySelector('collection-component');
    if(target) new MutationObserver(records=>{
      if(records.some(record=>Array.from(record.addedNodes).some(node=>
        node.nodeType===1 && (node.matches?.('.product-grid__item,#ResultsList,.product-grid,results-list')||node.querySelector?.('.product-grid__item'))))) schedule();
    }).observe(target,{childList:true,subtree:true});
    document.addEventListener('shopify:section:load',schedule);
    renderPrice();refresh();
  }
  function start(){document.querySelectorAll('[data-bf-filter-panel]').forEach(init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
  document.addEventListener('shopify:section:load',start);
})();